var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 601,
    viewBox: "0 0 1200 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_48)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_15_48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1212.5,
    cy: 604.5,
    rx: 145.5,
    ry: 69.5,
    fill: "#E87CDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_15_48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.5,
    cy: 69.5,
    rx: 145.5,
    ry: 69.5,
    fill: "#A864FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1177 599C1177 450.744 1116.26 308.56 1008.15 203.727C900.032 98.8945 753.397 40 600.5 40C447.603 40 300.968 98.8944 192.853 203.727C84.7383 308.56 24 450.744 24 599L600.5 599H1177Z",
    fill: "url(#paint0_linear_15_48)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15_48",
    x: 717,
    y: 185,
    width: 991,
    height: 839,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_15_48"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_15_48",
    x: -330,
    y: -330,
    width: 951,
    height: 799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 165,
    result: "effect1_foregroundBlur_15_48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_48",
    x1: 614.547,
    y1: 40,
    x2: 617.385,
    y2: 504.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 601,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutHeading);
export default __webpack_public_path__ + "static/media/about-Heading.e470d309d066a788c905cdcf313bc029.svg";
export { ForwardRef as ReactComponent };